import { useEffect, useState } from 'react';
import voiceService from '@services/voice.service';
import { useAuthStore } from '@stores/authStore';

/**
 * Whether this user can place calls. False until known, and if it can't be found
 * out. Light agents are refused by the server, so they aren't offered it.
 */
export function useOutboundAvailable(): boolean {
  const lightAgent = useAuthStore((s) => s.user?.role) === 'light_agent';
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    if (lightAgent) return;
    let live = true;
    voiceService
      .getOutboundAvailability()
      .then(({ available: yes }) => {
        if (live) setAvailable(yes);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [lightAgent]);

  return available && !lightAgent;
}
